import MySwal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import "bootstrap/dist/css/bootstrap.min.css";
import SwalTitleComponent from "./PreviewWindow/Samples/SwalTitleComponent";
import SwalHtmlComponent from "./PreviewWindow/Samples/SwalHtmlComponent";
import { faCircleCheck, faCircleInfo, faCircleXmark, faCircleQuestion, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

const mySwal = withReactContent(MySwal)

const styles = `
  .swal2-actions {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin: 0px;
  }
  
  .swal2-confirm {
    margin: 5px !important;
    padding: 10px 18px;
  }
  .swal2-cancel {
    margin-right: 25px !important;
  }
  .swal2-ok {
    margin: 32px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;
    font-weight: 500 !important;
  }

  .swal2-actions-button {
    margin-top: 32px !important;
  }
  
`

// Add the styles to the document
const styleSheet = document.createElement("style")
styleSheet.type = "text/css"
styleSheet.innerText = styles
document.head.appendChild(styleSheet)

export const showError = (title: string, message: string) => {
  return mySwal.fire({
    title: <SwalTitleComponent icon={faCircleXmark} title={title} color={"danger"} />,
    html: <SwalHtmlComponent message={message} />,
    showConfirmButton: true,
    confirmButtonText: "OK",
    confirmButtonColor: "#9f004f",
    allowOutsideClick: false,
    customClass: {
      actions: 'swal-actions-success-error',
      confirmButton: 'btn-success swal2-confirm btn-font-swal btn swal2-ok',
    }
  });
}

export const showSuccess = (title = "", message = "") => {
  return mySwal.fire({
    title: <SwalTitleComponent icon={faCircleCheck} title={title} color={"success"} />,
    html: <SwalHtmlComponent message={message} />,
    showConfirmButton: true,
    confirmButtonText: "OK",
    confirmButtonColor: "#9f004f",
    allowOutsideClick: false,
    customClass: {
      actions: 'swal-actions-success-error',
      confirmButton: 'btn-success swal2-confirm btn-font-swal btn swal2-ok ',
    }
  })
}

export const showConfirm = (title = "Confirm", message = "Are you sure, you want to logout", confirmButtonText = "Confirm", cancelButtonText = "Cancel", titleColor = "black") => {
  return mySwal.fire({
    title: <SwalTitleComponent icon={faCircleQuestion} title={title} color={"secondary"} />,
    html: <SwalHtmlComponent message={message} />,
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonColor: "#9f004f", //"#dc3545",
    confirmButtonText: confirmButtonText.toUpperCase(),
    cancelButtonText: (cancelButtonText || "Cancel").toUpperCase(),
    allowOutsideClick: false,
    customClass: {
      actions: 'swal-actions-end swal2-actions-button',
      confirmButton: 'btn-success swal2-confirm btn btn-font-swal',
      cancelButton: 'btn-secondary swal2-confirm btn btn-font-swal',
    }
  })
}

export const myMessageFunction = async (confirmButtonText: string, saveRequired: boolean) => {
  let title;
  let message;
  let denyButtonText;
  let cancelButtonText;
  const auth = { editor: true, publisher: false };
  if (auth.editor === true && auth.publisher === false) {
    title = "Confirm";
    message = "Are you sure you want to save theme?";
    confirmButtonText = confirmButtonText;
    if (saveRequired) denyButtonText = "Save";
    cancelButtonText = "Cancel";
  }

  return mySwal.fire({
    title: <SwalTitleComponent icon={faCircleQuestion} title={title} color={"secondary"} />,
    html: <SwalHtmlComponent message={message} />,
    showDenyButton: saveRequired,
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonColor: "#9f004f",
    denyButtonColor: "#9f004f",
    confirmButtonText: confirmButtonText.toUpperCase(),
    cancelButtonText: (cancelButtonText || "Cancel").toUpperCase(),
    denyButtonText: (denyButtonText || "").toUpperCase(),
    allowOutsideClick: false,
    allowEnterKey: true,
    allowEscapeKey: true,
    scrollbarPadding: false,
    customClass: {
      actions: "swal2-actions-button",
      confirmButton: 'btn-success swal2-confirm btn btn-font-swal',
      cancelButton: 'btn-secondary swal2-confirm btn btn-font-swal',
      denyButton: 'btn-success swal2-confirm btn btn-font-swal'
    },
    width: '600px' // Increase the width of the Swal
  });
}


export const showReject = (title: string, editorName: string, affiliateName: string) => {
  const titleContent = `
  <div class='row'>
    <div class='col-1 me-4'>
      <i class='fa fa-circle-check me-3 text-danger' style='font-size: large;'></i>
    </div>
    <div class='col-8 ps-2 ps-sm-0 px-0 d-flex justify-content-start align-items-center'>
      <h3 class='fw-bold'>${title}</h3>
    </div>
  </div>`;

  const htmlContent = `
    <div class="my-class">
      <div class="row pb-2">
        <div class="col-md-8 text-start text-black">
          <strong>Affiliate: </strong>${affiliateName}
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 text-start  text-black">
          <strong>Editor: </strong>${editorName}
        </div>
      </div>
    </div>`;

  return mySwal.fire({
    title: <SwalTitleComponent icon={faCircleInfo} title={title} color={"secondary"} />,
    // html: <SwalHtmlComponent message={message} />,
    html: htmlContent,
    input: "textarea",
    inputPlaceholder: "Add Comment...",
    inputAttributes: {
      "aria-label": "Add Comment"
    },
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonColor: "#9f004f", //"#dc3545",
    confirmButtonText: "Reject",
    cancelButtonText: "Cancel",
    allowEnterKey: true,
    allowOutsideClick: false,
    allowEscapeKey: true,
    heightAuto: true,
    scrollbarPadding: false,
    inputValidator: (value) => {
      if (!value) {
        return 'Please add your comment!';
      }
    },
    customClass: {
      actions: "my-actions",
      // confirmButton: "order-1 left-gap",
      // cancelButton: "order-2",
      confirmButton: 'btn-success swal2-confirm btn btn-font-swal',
      cancelButton: 'btn-secondary swal2-confirm btn btn-font-swal',

    },
  });
};


export function showAlert({
  title = "Are you sure?",
  confirmButtonText = "OK",
  confirmCallback = () => { }
}) {
  mySwal.fire({
    title: <SwalTitleComponent icon={faCircleQuestion} title="SESSION EXPIRING" color={"secondary"} />,
    html: <SwalHtmlComponent message={title} />,
    showCancelButton: false,
    confirmButtonColor: "#3085d6",
    allowOutsideClick : false,
    confirmButtonText,
    customClass: {
      actions: 'swal-actions-success-error',
      confirmButton: 'btn-success swal2-confirm swal2-ok btn btn-font-swal',
    }
  }).then((result) => {
    if (result.isConfirmed) {
      confirmCallback();
    }
  });
}


export default mySwal;
